/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import styled from 'styled-components';

/**
 * Internal dependencies
 */

const Area = styled.div.attrs(({ $isDisabled }) => ({
  'aria-disabled': $isDisabled ? 'true' : undefined,
  inert: $isDisabled ? '' : undefined,
}))`
  grid-area: ${({ area }) => area};
  position: relative;
  overflow: hidden;
  z-index: ${({ zIndex }) => zIndex};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
`;

const CanvasArea = styled(Area).attrs({ area: 'canv', zIndex: 1 })``;
const InspectorArea = styled(Area).attrs({ area: 'insp', zIndex: 2 })``;

export { CanvasArea, InspectorArea };
